<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang].title : ''" type="white">
        <template v-slot:body>
            <Policy />
        </template>
    </Page>
</template>

<script>
import Page     from '@/components/sides/Page.vue' 
import Policy    from '@/components/public/Policy.vue'
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en:{
                    title: "Policy",
                },
                ru:{
                    title: "Политика конфиденциальности",
                }
            },
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    components: {
        Page,
        Policy
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
    },
    mounted() {
        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>